import { User } from '@/state/reducers/authSlice';
import { Metadata } from 'nice-grpc-web';
import { v4 as uuidv4 } from 'uuid';

import { FindAccountPropertiesByCode } from '@/compiled_proto/com/celertech/staticdata/api/account/property/UpstreamAccountPropertyProto';
import { accountPropertyServiceClient } from '@/helpers/environmentHelper';
import { Logger } from '@/utils/logger';


export async function getAccountProperties(account: string, credentials: User) {
    // Market order
    const findAccountPropertiesByCodeRequest = FindAccountPropertiesByCode.fromPartial({
        clientRequestId: uuidv4(),
        code: account
    });

    const findAccountPropertiesByCodeResponse = await accountPropertyServiceClient.unary.findAccountPropertiesByCode(
        findAccountPropertiesByCodeRequest,
        {
            metadata: Metadata({
                'authorization-token': credentials.authToken
            })
        }
    );

    Logger({
        title: 'Outbound: Find Account Properties By Code Response',
        callback: () => {
            console.log({
                findAccountPropertiesByCodeRequest,
                findAccountPropertiesByCodeResponse
            });
        }
    });
    return findAccountPropertiesByCodeResponse?.accountProperties || [];
}
